export default __webpack_public_path__ + "static/media/superhelte.fe7af6e2.jpg";